import useTestId from '@ori/testid-generator';
import bemCssModules from 'bem-css-modules';
import type { VFC } from 'react';
import { useLocation } from 'react-router-dom';

import SearchHeaderModuleCss from './SearchHeader.module.css';
import { SearchHeaderTitle } from './SearchHeaderTitle';
import { Breadcrumbs } from '~/components/BreadCrumbs/Breadcrumbs';
import { SearchInput } from '~/components/SearchInput/SearchInput';
import type { SearchResultStore } from '~/stores';
import { useSearchResultStore } from '~/stores';

const block = bemCssModules(SearchHeaderModuleCss);

export const SearchHeader: VFC = () => {
  const rootPath = '/';
  const path = useLocation();
  const isRootPath = rootPath === path.pathname;
  const { resetSearchResults }: SearchResultStore = useSearchResultStore();

  if (isRootPath) {
    resetSearchResults();
  }

  const { getTestId } = useTestId();

  return (
    <div
      className={block()}
      data-testid={getTestId('top-banner')}
    >
      <div
        className={block('breadcrumbs')}
        data-testid={getTestId('top-banner-breadcrumbs')}
      >
        <Breadcrumbs />
      </div>
      <SearchHeaderTitle isRootPath={isRootPath} />
      <SearchInput />
    </div>
  );
};
